import { useEffect } from "react";
import * as React from "react";

/* eslint import/no-webpack-loader-syntax: off */
// @ts-expect-error
import css from "!raw-loader!./bottom-bar.css";

//QUERY

import { useQueryClient } from "@tanstack/react-query";

//ICONS

import AddSceneIcon from "../../Icons/AddSceneIcon.tsx";
import { Asset, Hotspot, Scene } from "../../../Types.ts";
import { UseAssetsQuery, UseGetTour } from "../../../api/calls/Queries.ts";
import BottomBarThumbnail from "./BottomBarThumbnail";
import {
  useCurrentSceneStore,
  useEditingElementStore,
  useParametersStore,
  useWidePopupStore,
} from "../../../api/Zustand.ts";
import { useRightSidePanelStore } from "../../../state management/zustand/editor-elements-stores.ts";
import { useGLRendererStore } from "../../../state management/zustand/gl-stores.ts";
import { getLanguageFile } from "../../common/GetLanguageFile.ts";

function BottomBar() {
  const { tourID } = useParametersStore();

  const { data: tourData } = UseGetTour(tourID);

  const { data: panos } = UseAssetsQuery(tourID, 1);

  const queryClient = useQueryClient();

  const { setEditingElem } = useEditingElementStore();

  const rightPanel = useRightSidePanelStore();

  const { currentSceneID, setCurrentSceneID } = useCurrentSceneStore();

  // useEffect(() => {
  //   if (tourData?.startingScene && currentSceneID === -1) {
  //     setCurrentSceneID(tourData?.startingScene);
  //   }
  // }, [tourData?.startingScene, currentSceneID, setCurrentSceneID]);

  const camera = useGLRendererStore((state) => state.state?.camera);

  const onSceneAdd = React.useCallback(() => {
    // RESETTING CAMERA POSITION
    camera?.position.set(0, 0, -1);

    const randomlyGenId = Math.floor(10000000 + Math.random() * 90000000);

    if (tourData!.scenes.find((one: Scene) => one.isNew)) {
      return null;
    } else {
      if (tourData!.scenes.length === 0) {
        queryClient.setQueryData(["GetTour", tourID], {
          ...tourData,
          startingScene: 1,
          scenes: [
            {
              id: 1,
              title: "Nuova Scena",
              image: "",
              fov: tourData!.fov,
              rotation: 0,
              lockRotation: false,
              north: 0,
              isNew: true,
              hotspots: [],
            },
          ],
        });
        setCurrentSceneID(1);

        setEditingElem("scene", 1);
        rightPanel.setOpen(true);
      } else {
        queryClient.setQueryData(["GetTour", tourID], {
          ...tourData,
          scenes: [
            ...tourData!.scenes,
            {
              id: randomlyGenId,

              title: "Scena " + (tourData?.scenes.length! + 1),
              image: "",
              fov: tourData!.fov,
              rotation: 0,
              lockRotation: false,
              north: 0,
              isNew: true,
              hotspots: [],
            },
          ],
        });
        setCurrentSceneID(randomlyGenId);

        setEditingElem("scene", randomlyGenId);
        rightPanel.setOpen(true);
      }
    }
  }, [
    camera,
    rightPanel,
    queryClient,
    setCurrentSceneID,

    setEditingElem,
    tourData,
    tourID,
  ]);

  const { isTakingScreenshot } = useWidePopupStore();

  const addSceneIsBlocked: boolean = React.useMemo(() => {
    return (
      !!tourData?.scenes
        .find((one: Scene) => one.id === currentSceneID)
        ?.hotspots.find((one: Hotspot) => one.isNew || one.EDIT_POS) ||
      isTakingScreenshot
    );
  }, [currentSceneID, isTakingScreenshot, tourData?.scenes]);

  const spotInTempState = React.useMemo(() => {
    return tourData?.scenes
      .find((one: Scene) => one.id === currentSceneID)
      ?.hotspots.find((one: Hotspot) => one.EDIT_POS || one.isNew);
  }, [tourData, currentSceneID]);

  return (
    <>
      <style>{css}</style>
      <ul className="bottom-bar">
        {tourData &&
          panos &&
          tourData?.scenes.map((scene: Scene, index: number) => (
            <BottomBarElement
              key={scene.id}
              index={index}
              scene={scene}
              panos={panos}
              spotInTempState={spotInTempState}
            ></BottomBarElement>
          ))}

        <li
          id="add"
          onClick={() => {
            if (addSceneIsBlocked) return;
            else onSceneAdd();
          }}
          style={{ height: "100%" }}
        >
          <div className="add-scene">
            <AddSceneIcon />
            <p style={{ textAlign: "center", fontWeight: "500" }}>
              {getLanguageFile("bottom_bar.add_scene").toLocaleUpperCase()}
            </p>
          </div>
        </li>
      </ul>
    </>
  );
}

export default BottomBar;

const BottomBarElement = (props: {
  scene: Scene;
  index: number;
  spotInTempState: Hotspot | undefined;
  panos: Asset[];
}) => {
  const { currentSceneID, setCurrentSceneID } = useCurrentSceneStore();
  const { isTakingScreenshot } = useWidePopupStore();

  const { setEditingElem } = useEditingElementStore();
  const { scene, spotInTempState, index, panos } = props;

  const elementRef = React.useRef<HTMLLIElement>(null);

  const rightPanel = useRightSidePanelStore();

  const isSelected = currentSceneID === scene.id;

  React.useEffect(() => {
    if (scene.id === currentSceneID) {
      elementRef.current?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
      });
    } else return;
  }, [elementRef, scene, currentSceneID]);

  return (
    <li
      ref={elementRef}
      key={scene.id}
      onDoubleClick={() => {
        if (spotInTempState || isTakingScreenshot) return;
        else {
          rightPanel.setOpen(true);
        }
      }}
      onClick={() => {
        if (spotInTempState || isTakingScreenshot) return;
        else {
          if (currentSceneID !== scene.id) {
            setCurrentSceneID(scene.id as number);
            setEditingElem("scene", scene.id);
          }
        }
      }}
    >
      <div
        className={`scene-element ${spotInTempState && "disabled"} ${
          isSelected && " selected"
        }`}
      >
        <div>
          {index + 1 <= 9
            ? 0 + JSON.stringify(index + 1)
            : JSON.stringify(index + 1)}
        </div>

        <div style={{ flexGrow: 1, position: "relative" }}>
          <div className={`thumbnail-wrapper ${isSelected && "selected"}`}>
            <BottomBarThumbnail
              thumb={
                panos?.find((one) => one.assetId === scene.imageID)
                  ?.assetKeyThumb || scene.imageThumb
              }
            />
          </div>
        </div>
        <div
          style={{
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {scene.title || scene.id}
        </div>
      </div>
    </li>
  );
};
